import { render, staticRenderFns } from "./EditStageTournament.vue?vue&type=template&id=59283bca&scoped=true"
import script from "./EditStageTournament.vue?vue&type=script&lang=js"
export * from "./EditStageTournament.vue?vue&type=script&lang=js"
import style0 from "./EditStageTournament.vue?vue&type=style&index=0&id=59283bca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59283bca",
  null
  
)

export default component.exports